exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.stand-pagination-table-container[data-v-62731f22] {\n    height: 100%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n.vxe-table[data-v-62731f22] {\n        -webkit-box-flex: 1;\n            -ms-flex-positive: 1;\n                flex-grow: 1;\n}\n.vxe-pager[data-v-62731f22] {\n        -ms-flex-negative: 0;\n            flex-shrink: 0;\n        padding-top: 8px;\n}\n}\n", ""]);

// exports
